import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import {EventsManager} from "../../events/events.manager";
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [NgIf]
})
export class FooterComponent implements OnInit {
  year: number = 0;
  environment:any = environment;
  footerText:string = '';
  constructor(public em: EventsManager) { }

  ngOnInit(): void {
    this.year = moment().year();

    this.em.homePageDetailUpdated.subscribe(
      (event: any) => {
        this.footerText = this.em?.homePageDetails?.salesPlanMarketingDetails?.footer.at(0)?.value.at(0);
      })
  }

}
